import React from 'react';
import { motion } from 'framer-motion';
import { Target, Heart, Zap } from 'lucide-react';
export function Slide03Persona() {
  return <div className="w-full h-full flex items-center px-[clamp(4rem,8vw,10rem)] gap-[clamp(3rem,6vw,6rem)] relative" data-id="element-70">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[var(--surface-alt)]/30 rounded-l-[100px] -z-10" data-id="element-71" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="flex-1 bg-[var(--surface)] rounded-[3rem] p-12 border border-[var(--surface-alt)] shadow-xl shadow-[var(--fg)]/5 relative overflow-hidden" data-id="element-72">
        <div className="relative z-10" data-id="element-73">
          <div className="flex items-center gap-6 mb-10" data-id="element-74">
            <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1061&auto=format&fit=crop" alt="Persona" className="w-24 h-24 rounded-full object-cover border-4 border-[var(--bg)] shadow-md" data-id="element-75" />
            <div data-id="element-76">
              <div className="inline-block px-3 py-1 bg-[var(--surface-alt)] text-[var(--fg)] rounded-full text-xs font-bold tracking-widest uppercase mb-2" data-id="element-77">
                Target Persona
              </div>
              <h2 className="font-display text-4xl" data-id="element-78">The "Optimized" Eater</h2>
              <p className="text-lg text-[var(--fg-muted)] font-medium" data-id="element-79">
                High intent, low time.
              </p>
            </div>
          </div>

          <div className="space-y-8" data-id="element-80">
            <div className="flex gap-5" data-id="element-81">
              <div className="w-10 h-10 rounded-xl bg-[var(--bg)] flex items-center justify-center shrink-0 shadow-sm border border-[var(--surface-alt)]" data-id="element-82">
                <Target className="text-[var(--accent)]" size={20} data-id="element-83" />
              </div>
              <div data-id="element-84">
                <h4 className="font-semibold text-lg mb-1" data-id="element-85">Goal</h4>
                <p className="text-[var(--fg-muted)] leading-relaxed" data-id="element-86">
                  Wants to hit protein targets without spending Sunday afternoon
                  meal prepping.
                </p>
              </div>
            </div>
            <div className="flex gap-5" data-id="element-87">
              <div className="w-10 h-10 rounded-xl bg-[var(--bg)] flex items-center justify-center shrink-0 shadow-sm border border-[var(--surface-alt)]" data-id="element-88">
                <Heart className="text-[var(--accent)]" size={20} data-id="element-89" />
              </div>
              <div data-id="element-90">
                <h4 className="font-semibold text-lg mb-1" data-id="element-91">Pain Point</h4>
                <p className="text-[var(--fg-muted)] leading-relaxed" data-id="element-92">
                  Cancels subscription when life gets busy because picking meals
                  feels like "homework".
                </p>
              </div>
            </div>
            <div className="flex gap-5" data-id="element-93">
              <div className="w-10 h-10 rounded-xl bg-[var(--bg)] flex items-center justify-center shrink-0 shadow-sm border border-[var(--surface-alt)]" data-id="element-94">
                <Zap className="text-[var(--accent)]" size={20} data-id="element-95" />
              </div>
              <div data-id="element-96">
                <h4 className="font-semibold text-lg mb-1" data-id="element-97">Behavior</h4>
                <p className="text-[var(--fg-muted)] leading-relaxed" data-id="element-98">
                  Trusts algorithms for music and media; ready to trust them for
                  food.
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      x: 30
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: 0.3,
      duration: 0.6
    }} className="flex-1 pl-8 border-l-2 border-[var(--accent)]/20" data-id="element-99">
        <h3 className="font-display text-[clamp(2.5rem,3.5vw,4rem)] leading-[1.15] mb-8 text-[var(--fg)]" data-id="element-100">
          "I just want someone to tell me what to eat to hit my macros, and have
          it show up at my door."
        </h3>
        <div className="flex items-center gap-4" data-id="element-101">
          <div className="h-px w-8 bg-[var(--fg-muted)]" data-id="element-102" />
          <p className="text-xl text-[var(--fg-muted)] font-medium tracking-wide" data-id="element-103">
            User Interview #14 (Sarah, 29)
          </p>
        </div>
      </motion.div>
    </div>;
}